<template>
  <div class="">
     <el-radio-group v-model="checkName">
      <el-radio 
        v-for="item in list"
        :key="item.name"
        :label="item.name"
        class="radio-sheet"
        :disabled="disabled"
       />
    </el-radio-group>
    <div class="footer">
      <el-button @click="$emit('close')">Cancel</el-button>
      <el-button type="primary" @click="handleSave">Save</el-button>
    </div>
  </div>
</template>

<script>
import { validEmoji, validHtml } from "@/utils/validate.js"
export default {
  props: [ 'cbs', 'list', 'check', 'disabled' ],
  data() {
    return { 
      checkName: this.check
    }
  },
  mounted() {
      
  },
  methods: {
    handleSave() {
      if (!this.checkName) {
        this.$message.error('请指定一个sheet');
        return;
      }
      const data = this.list.find(v=> {
        return this.checkName === v.name;
      });
      this.cbs.onSubmit(data)
    },
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    text-align: center;
    margin-top: 20px;
  }
  .radio-sheet {
    margin-bottom: 10px;
    max-width: 50%;
  }
</style>
